'use client'

import Link from 'next/link'
import s from './Teams.module.scss'
import { useEffect, useRef, useState } from 'react'
import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion'
import LazyImage from '@/components/Common/LazyImage'
import { PortableText } from 'next-sanity'
import { portableBlockComponents } from '@/utils/portableText'

type Props = { teams: any }

export default function TeamsComponent({ teams }: Props) {

    const containerRef = useRef<HTMLDivElement>(null)

    return (
        <div className={s.teams} ref={containerRef}>
            <div className={s.title}>
                <h2 id="about-teams-heading">{'Teams'}</h2>
            </div>
            <div className={s.contentContainer}>
                {teams?.map((team: any, index: number) => (
                    <div key={index} className={s.clientItem}>
                        <p translate='no'>
                            {team.website ? (
                                <Link href={team.website} target="_blank" rel="noopener noreferrer nofollow">
                                    {team.name}{team.position && `, ${team.position}`} ↗
                                </Link>
                            ) : (
                                <>{team.name}{team.position && `, ${team.position}`}</>
                            )}
                        </p>
                    </div>
                ))}
            </div>
            <div className={s.contentContainerImages}>
                {teams?.map((team: any, index: number) =>
                {
                    if ( !team.featuredImage ) return null;
                    return (
                    <div key={`featuredImage-${index}`} className={s.clientItem}>
                        <LazyImage
                            src={team.featuredImage.imageUrl}
                            alt={team.name}
                            width={team.featuredImage.metadata?.dimensions?.width || 200}
                            height={team.featuredImage.metadata?.dimensions?.height || 200}
                        />
                        <p translate='no' className={s.memberName}>{team.name}</p>
                        {team.bio && team.bio.length > 0 && (
                            <div className={s.memberBio}>
                                {team.bio.map((textRow: any) => (
                                    <PortableText
                                        key={textRow._key}
                                        value={[textRow]}
                                        components={portableBlockComponents()}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                    )
                }
                )}
            </div>
        </div>
    )
}